import s from '../collegesItem.module.css'
import {Button} from "antd";
import {useAddAlert} from "@/hooks/useAddAlert";

const ModalChengeVks = ({setActive, save}) => {
  const addAlert = useAddAlert();
 
  const update = () => {
    save(true);   
    setActive(false);
  }

  const noUpdate = () => {
    save();
    setActive(false);
  }

  return <div className="modal_departments">
    <h2 className="modal__title">Изменить ВКС?</h2>
    <div className={s.body}>
          <span style={{fontSize:'16px', color:'#000000e0', fontWeight:'400', marginBottom:'0px'}}>Вы ввели новую ссылку на ВКС, нужно ли обновить ссылки на онлайн занятия?</span>
        
          <Button onClick={update}>Обновить и сохранить профиль</Button>
          <Button onClick={noUpdate}>Не обновлять и сохранить профиль</Button>
          <Button onClick={()=>{
            setActive(false);
          }}>Закрыть</Button>
    </div>
  </div>
}
export default ModalChengeVks;